import React from 'react';
import PropTypes from 'prop-types';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import isEmpty from 'lodash/isEmpty';

const loaderStyle = {
  position: 'relative',
}

const RefreshLoader = <RefreshIndicator
  size={50}
  left={0}
  top={0}
  style={loaderStyle}
  status="loading"
/>

const LoaderOverlay = ({ visible = true, children }) => {
  const style = {
    display: (visible ? 'flex' : 'none'),
    position: 'fixed',
    top: 48,
    left: '0',
    zIndex: 500,
    width: '100%',
    height: '100%',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(244,244,244,0.6)',
  }

  if (isEmpty(children)) {
    children = RefreshLoader;
  }

  return (
    <div style={style}>
      {children}
    </div>
  )
}

LoaderOverlay.propTypes = {
  visible: PropTypes.bool,
  children: PropTypes.any,
}

export { LoaderOverlay as default, RefreshLoader };



// WEBPACK FOOTER //
// ./src/components/LoaderOverlay/index.jsx